import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { getControl } from '@shared/helpers/form.helper';

@Pipe({
    name: 'formControl',
})
export class FormControlPipe implements PipeTransform {
    transform(group: FormGroup, path: string): FormControl {
        return getControl(group, path);
    }
}
